













import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { Emit } from '@/node_modules/nuxt-property-decorator'

@Component({
  model: {
    prop: 'checked',
    event: 'change'
  }
})
export default class AtomRadioButton2 extends ComponentVue {
  @Prop({ type: String })
  name!: string

  @Prop({ type: [String, Number] })
  value!: string

  @Prop({ type: [Boolean] })
  checked!: boolean

  @Prop({ type: String })
  label!: string

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  @Emit('change')
  onChange(): string | number {
    this.$logger.debug('AtomRadioButton', 'onChange', 'value=', this.value)
    return this.value
  }
}
